import { useForm, UseFormProps } from "react-hook-form";

export interface JobsFiltersForm {
  position: string;
  location: string;
  macrofunction: string;
}

export function useJobsFiltersForm(props?: UseFormProps<JobsFiltersForm>) {
  const form = useForm<JobsFiltersForm>({
    defaultValues: {
      position: "",
      location: "",
      macrofunction: "",
    },
    ...props,
  });

  return form;
}
